import { FC } from 'react';
import { MaterialSymbol, Tooltip, withStyles } from 'vopay';
import styles from './AvailableVia.module.scss';
import PaymentMethodLogo from '@/components/UI/PaymentMethodLogo';
import { PaymentMethod } from '@/hooks/usePaymentMethods';

const cn = withStyles(styles);

type AvailableViaProps = {
  method: PaymentMethod;
  length?: number;
};

const PaymentRailItems: FC<{ paymentMethods: Array<PaymentMethod>; inline?: boolean }> = ({
  paymentMethods,
  inline = false,
}) => {
  return (
    <span className={cn('AvailableViaItems', !inline && 'AvailableViaItemsInline')}>
      <p className={cn('title')}>Available via:</p>
      <span className={cn('AvailableViaItemsAggregator')}>
        {paymentMethods?.map((item, idx) => (
          <PaymentMethodLogo
            key={item?.token === undefined ? `${item}-${idx}` : item.token + idx}
            method={item?.type}
            bankId={item?.bankId}
            creditCardBrand={item?.creditCardBrand}
            paymentRail={item?.paymentRails}
            size="19px"
          />
        ))}
      </span>
    </span>
  );
};

const AvailableVia: FC<AvailableViaProps> = ({ method, length }) => {
  const paymentRails = method?.paymentRails?.split(',')?.map((item) => ({ method: item, paymentRails: item })) ?? [];
  const groupedPaymentMethods = method?.groupedItems?.concat(method.kind !== 'HOLDER' ? method : []) ?? [];

  const combinedPaymentMethods = [...paymentRails, ...groupedPaymentMethods] as PaymentMethod[];
  const splicedPaymentMethods = combinedPaymentMethods?.slice(0, length);

  const showMoreTooltip = splicedPaymentMethods?.length < combinedPaymentMethods?.length;

  return (
    <span className={cn('AvailableVia')}>
      <PaymentRailItems paymentMethods={splicedPaymentMethods} inline />
      {showMoreTooltip && (
        <Tooltip
          hasButton={false}
          information={<PaymentRailItems paymentMethods={combinedPaymentMethods} />}
          position="right"
          customElement={<MaterialSymbol icon="more_horiz" size="18px" />}
        />
      )}
    </span>
  );
};

export default AvailableVia;
